import { INTERNAL_CONSTANTS } from '@constants/internalConstants'

const ENV = import.meta.env

export const environmentConfigurations = {
  runningGameEnvironment: ENV.VITE_RUNNING_ENVIRONMENT,
  appName: ENV.VITE_APP_NAME || 'Crash Render Engine',
  crashGameGraphqlBaseURL: ENV.VITE_CRASH_GAME_GRAPHQL_BASE_URL,
  crashGameSocketBaseURL: ENV.VITE_CRASH_GAME_SOCKET_BASE_URL,
  crashGameSocketPath: ENV.VITE_CRASH_GAME_SOCKET_PATH || '/socket.io',
  crashGameLoggerStatus: ENV.VITE_CRASH_GAME_LOGGER_STATUS,
  // Per-game canvas (iframe) URLs — only the URL differs per game.
  canvasUrlDefender: ENV.VITE_CANVAS_URL_DEFENDER,
  canvasUrlHowzzat: ENV.VITE_CANVAS_URL_HOWZZAT,
  canvasUrlRocketBoom: ENV.VITE_CANVAS_URL_ROCKET_BOOM,
  // External chat iframe (game-chat-client) — shared across games; identity is
  // passed via URL query params (built dynamically in chatContract.buildChatSrc).
  chatUrl: ENV.VITE_CHAT_URL,
}

export const isProduction =
  environmentConfigurations.runningGameEnvironment === INTERNAL_CONSTANTS.ENVIRONMENT.PRODUCTION
export const isStaging =
  environmentConfigurations.runningGameEnvironment === INTERNAL_CONSTANTS.ENVIRONMENT.STAGING
export const isLocal =
  environmentConfigurations.runningGameEnvironment === INTERNAL_CONSTANTS.ENVIRONMENT.LOCAL

const isLoggerOn = String(environmentConfigurations.crashGameLoggerStatus ?? '').trim().toUpperCase() === 'ON'

if (!isProduction && isLoggerOn) {
  console.info(`${environmentConfigurations?.appName} Configurations : `)
  console.table(environmentConfigurations)
}

if (!environmentConfigurations) {
  console.error('⚠️ Crash Render Engine config is not defined. Please check environment variables.')
  console.error(
    `⚠️ ${environmentConfigurations?.appName} Configurations is not defined. Please check environment variables.`
  )
}
